<form
    class="flex h-60 w-80 flex-col p-10"
    [formGroup]="form">
    <h1 class="mb-5 text-center text-xl">Copy this offer's goals to</h1>
    <mat-form-field class="w-full">
        <mat-label>Offer id</mat-label>
        <mat-select formControlName="offerId">
            @for (offer of data.offers | appOrderBy: "id"; track $index) {
                <mat-option [value]="offer.id">
                    {{ offer.id }}
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
    <button
        mat-flat-button
        color="primary"
        [disabled]="form.invalid"
        (click)="close()">
        Copy
    </button>
</form>
